angular.module('clientDashboardApp').controller("LocationUploadCtrl", function ($state, $scope, Upload, $interval, locationUploadService, $http, accountsService, Socket) {
    $scope.auditOnly = false;
    $scope.currentStep = 1;
    $scope.failedUpload = false;
    $scope.uploadComplete = false;
    $scope.validationComplete = false;
    $scope.locationsComplete = false;
    $scope.ind = 0;
    $scope.uploadStatusMsg = "Uploading";
    $scope.validationStatusMsg = "Validating Entries";
    $scope.locationStatusMsg = "Creating Locations";
    $scope.collapse = [false, false, false, false, false, false, false];
    $scope.stepLT = [false, true, true, true, true, true, true];
    $scope.stepGT = [true, false, false, false, false, false, false];
    $scope.buttonClass = ["", "", "", "", "", "", ""];
    $scope.toggleClass = ["", "", "", "", "", "", ""];

  // This initializes the socket connection, so it's ready for when we start the upload
  Socket.on("keepalive", (msg) => "nop")
  $scope.$on("$destroy", event => { Socket.off("keepalive") })

  $scope.upload = function (files) {
        if (files && files.length) {
            $scope.updateCurrentStep(2);

            for (var i = 0; i < files.length; i++) {
                var file = files[i];
                $scope.uploadProgress = 0;
                $scope.fileUploading = file.name;

                accountsService.getCurrentAccount().then(function(accountId) {
                Upload.upload({
                  url: '/admin/location/uploadLocations/upload',
                  fields: {
                    auditOnly: $scope.auditOnly,
                    accountId: accountId
                  },
                  file: file
                }).progress(function (evt) {
                  var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                  $scope.uploadProgress = progressPercentage;
                }).success(function (data, status, headers, config) {
                  $scope.uploadComplete = true;
                  startImport(data);
                }).error(function (data, status, headers, config) {
                  $scope.failedUpload = true;
                  showFailedError({message: "Problem uploading file: " + data});
                });
              });
            }
        }
    };

  function startImport(locationImport) {
    Socket.on("file-processing:" + locationImport.locationImportId, function (data) {
      handleLocationImportWSMessage(data);
    }).then(() => {
      $http.get("/admin/location/uploadLocations/import/" + locationImport.locationImportId).then(function (res) {
        // We set time out to allow the socket to receive remaining events and then we un subscribe.
        setTimeout(function () {
          Socket.off("file-processing:" + locationImport.locationImportId)
        }, 1000)
      });
    });

  }

    function handleLocationImportWSMessage(locationImportMessage) {

        switch (locationImportMessage.status) {
            case "Processing":
                showProcessing(locationImportMessage);
                break;
            case "Success":
                showSuccess(locationImportMessage);
                break;
            case "ValidationError":
                showValidationError(locationImportMessage);
                break;
            case "CreationError":
                showCreationError(locationImportMessage);
                break;
            case "Failed":
                showFailedError(locationImportMessage);
                break;
        }

    }

    function showSuccess(successMessage) {
        $scope.updateCurrentStep(6);
        $scope.locationImportSummary = successMessage.summary;
        $scope.uploadSuccess = true;
    }

    function showValidationError(validationErrorMessage) {
        $scope.updateCurrentStep(7);
        $scope.validationErrors = validationErrorMessage.errors;
    }

    function showCreationError(creationErrorMessage) {
        $scope.updateCurrentStep(8);
        $scope.creationErrors = creationErrorMessage.errors;
    }

    function showFailedError(failedMessage) {
        $scope.updateCurrentStep(8);
        console.log(failedMessage)
        $scope.error = failedMessage.message;
        $scope.errors = failedMessage.errors;
    }

    function showProcessing(processingMessage) {
        if (processingMessage.what == "ValidatingEntries") {
            $scope.totalValidated = processingMessage.completed;
            $scope.totalToValidate = processingMessage.total;
            $scope.validationProgress = (processingMessage.completed / processingMessage.total) * 100;

            if (processingMessage.completed == processingMessage.total)
                $scope.validationComplete = true;
            else
                $scope.updateCurrentStep(3);
        }
        else if (processingMessage.what == "CreatingLocations") {
            $scope.totalLocationsCreated = processingMessage.completed;
            $scope.totalLocationToCreate = processingMessage.total;
            $scope.locationsProgress = (processingMessage.completed / processingMessage.total) * 100;

            if (processingMessage.completed == processingMessage.total)
                $scope.locationsComplete = true;
            else
                $scope.updateCurrentStep(5);
        }
    }

    $scope.getCurrentStep = function () {
        return $scope.currentStep;
    };

    $scope.updateCurrentStep = function (step) {
        $scope.currentStep = step;
        $scope.stepManager($scope.currentStep);
        $scope.updateCollapsedArray(step);
        $scope.updateStepLTArray(step);
        $scope.updateStepGTArray(step);
        $scope.updateButtonClassArray(step);
        $scope.updateToggleClassArray(step);
    };

    $scope.stepManager = function (step) {
        switch (step) {
            case 1:
                break;
            case 2:
                break;
            case 3: // Validating entries
                $scope.uploadStatusMsg = "File Uploaded";
                break;
            case 4:
                $scope.validationStatusMsg = "Entries Validated";
                break;
            case 5: // Creating locations
                break;
            case 6: // Success
                $scope.locationStatusMsg = "Locations Added";
                break;

            default:
                break;
        }
    };

    $scope.spotCheck = function () {
        $('#spot-check-modal').modal();
    };

    $scope.updateSelectedLoc = function (dir) {
        if (dir == "dec") {
            if ($scope.ind > 0) {
                $scope.ind--;
            }
        }
        else if (dir == "inc") {
            if ($scope.ind < $scope.locations.length - 1) {
                $scope.ind++;
            }
        }
        $scope.selLoc = $scope.locations[$scope.ind];
    };

    $scope.updateToggleClassArray = function (step) {
        for (var x = 0; x < $scope.toggleClass.length; x++) {
            $scope.toggleClass[x] = $scope.stepLT[x] ? "inactive" : "active";
        }
    };

    $scope.updateButtonClassArray = function (step) {
        for (var x = 0; x < $scope.buttonClass.length; x++) {
            $scope.buttonClass[x] = x > 2 ? "" : "btn-disabled";
        }
    };

    $scope.updateCollapsedArray = function (step) {
        for (var x = 0; x < $scope.collapse.length; x++) {
            if ($scope.currentStep > x) {
                $scope.collapse[x] = true;
            }
        }
    };

    $scope.updateStepLTArray = function (step) {
        for (var x = 0; x < $scope.stepLT.length; x++) {
            if ($scope.currentStep < x) {
                $scope.stepLT[x] = true;
            }
            else {
                $scope.stepLT[x] = false;
            }
        }
    };

    $scope.updateStepGTArray = function (step) {
        for (var x = 0; x < $scope.stepGT.length; x++) {
            if ($scope.currentStep > x) {
                $scope.stepGT[x] = true;
            }
        }
    };

    $scope.reloadRoute = function() {
      $state.reload();
    };
});
